// AUTO-GENERATED — do not edit manually. Run: yarn generate:actions

export const ACTION_REGISTRY = {
  'nav:anchor-scroll': () => import('./nav/anchor-scroll'),
  'nav:redirect': () => import('./nav/redirect'),
  'rating:dochub-vote': () => import('./rating/dochub-vote'),
  'ui:dh-open-editor': () => import('./ui/dh-open-editor'),
  'ui:open-cookie': () => import('./ui/open-cookie'),
  'ui:open-popup': () => import('./ui/open-popup'),
  'ui:sn-open-editor': () => import('./ui/sn-open-editor'),
  'ui:ul-open-editor': () => import('./ui/ul-open-editor'),
  'upload:dochub-file': () => import('./upload/dochub-file'),
} as const;

export type ActionName = keyof typeof ACTION_REGISTRY;
